module.exports = __webpack_public_path__ + "static/paleosite_morphing5-2fcde6b2231c902cd4182e786d3aa2aa.jpg";